import type { IconSvgObject } from './types';

const AlphabetArabicIcon: IconSvgObject = [
  ["path", { d: "M9 4L9 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13 14H22C22 12 18.5 9.5 16.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 4V19C13 19.5523 12.5523 20 12 20H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 4V19C5 19.5523 4.55228 20 4 20H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default AlphabetArabicIcon;
